/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

/* export const getLastUpdatedList = (
  limitAmount: number,
  chain: string,
  orderBy: string,
  searchField = '',
) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      if (chain != 'all') {
        collectionRef = collectionRef.where('chain', '==', chain)
      }

      collectionRef = collectionRef.where('active', '==', true)

      if (searchField != '') {
        collectionRef = collectionRef
          .where('lowercase_name', '>=', searchField)
          .where('lowercase_name', '<=', searchField + '~')
          .orderBy('lowercase_name', 'desc')
      }

      if (orderBy == 'last_updated_at') {
        collectionRef = collectionRef.orderBy('last_updated_at', 'asc')
      } else {
        collectionRef = collectionRef.orderBy('stats.market_cap', 'desc')
      }

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          queryRef.docs.map((doc: any) => {
            // console.log('DOC', doc.data())
            // if (doc.data().floor_price == 0) {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)
            // }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLastUpdatedList | error', error)
      reject(error)
    }
  })
} */

/** Get latest flagged nft collection */
export const getLatestFlaggedCollections = (limitAmount: number, chain: string, reason: string) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.FLAGGED_COLLECTION)

      if (chain != 'all') {
        collectionRef = collectionRef.where('chain', '==', chain)
      }

      if (reason != '') {
        collectionRef = collectionRef.where('reason', '==', reason)
      }

      collectionRef = collectionRef.orderBy('created_at', 'desc')

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          if (queryRef.empty) {
            resolve(temp)
          }
          queryRef.docs.map((doc: any) => {
            // console.log('DOC', doc.data())
            // if (doc.data().floor_price == 0) {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)
            // }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLatestFlaggedCollections | error', error)
      reject(error)
    }
  })
}

/** Archive flagged nft collection */
export const archiveFlaggedCollection = (id: string) => {
  return new Promise((resolve, reject) => {
    try {
      /** Create a ref collection for invalid magic eden slug */
      const flaggedCollectionRef = getCollectionReference(collectionNames.FLAGGED_COLLECTION)

      flaggedCollectionRef.doc(id).delete()

      resolve({ success: true, id })
    } catch (error) {
      console.log('deleteMagicEdenSlug | error', error)
      reject(error)
    }
  })
}

/** Get latest flagged nft collection */
export const getLatestRequestedCollections = (
  limitAmount: number,
  chain: string,
  request_type: string,
) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.REQUEST_NEW_NFT_COLLECTION)

      if (chain != 'all') {
        collectionRef = collectionRef.where('project_chain', '==', chain)
      }

      if (request_type != '') {
        collectionRef = collectionRef.where('request_type', '==', request_type)
      }

      collectionRef = collectionRef.orderBy('created_at', 'desc')

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          if (queryRef.empty) {
            resolve(temp)
          }
          queryRef.docs.map((doc: any) => {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)
            // }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLatestRequestedCollections | error', error)
      reject(error)
    }
  })
}

/** Archive flagged nft collection */
export const archiveRequestedCollection = (id: string) => {
  return new Promise((resolve, reject) => {
    try {
      /** Create a ref collection for invalid magic eden slug */
      const flaggedCollectionRef = getCollectionReference(
        collectionNames.REQUEST_NEW_NFT_COLLECTION,
      )

      flaggedCollectionRef.doc(id).delete()

      resolve({ success: true, id })
    } catch (error) {
      console.log('archiveRequestedCollection | error', error)
      reject(error)
    }
  })
}

/** Get latest user feedback collection */
export const getLatestUserFeedback = (limitAmount: number, deviceType: string, reason: string) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      let collectionRef: any = getCollectionReference(collectionNames.USER_FEEDBACK)

      if (deviceType != 'all') {
        collectionRef = collectionRef.where('device_type', '==', deviceType)
      }

      if (reason != '') {
        collectionRef = collectionRef.where('reason', '==', reason)
      }

      collectionRef = collectionRef.orderBy('created_at', 'desc')

      collectionRef
        .limit(limitAmount)
        .get()
        .then((queryRef: any) => {
          let i = 0
          if (queryRef.empty) {
            resolve(temp)
          }
          queryRef.docs.map((doc: any) => {
            const point = {
              ...doc.data(),
              id: doc.id,
            }
            temp.push(point)

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error: any) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getLatestUserFeedback | error', error)
      reject(error)
    }
  })
}

/** Archive flagged nft collection */
export const archiveUserFeedback = (id: string) => {
  return new Promise((resolve, reject) => {
    try {
      /** Create a ref collection for invalid magic eden slug */
      const collectionRef = getCollectionReference(collectionNames.USER_FEEDBACK)

      collectionRef.doc(id).delete()

      resolve({ success: true, id })
    } catch (error) {
      console.log('archiveUserFeedback | error', error)
      reject(error)
    }
  })
}
